import './App.css';
import HEADER from './components/header';
import HERO from './components/hero';
import SERVICE from './components/service';
//import PROJECT from './components/project';
import ABOUT from './components/about';
import FOOTER from './components/footer';
import CONTACT from './components/contact';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import WhatsAppButton from './components/whatsapp';
import ScrollToTop from './components/ScrollToTop';
import StatsSection from './components/StatsSection';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <div className="App">
      <HEADER />
      <main>
        <HERO />
        <StatsSection />
        <SERVICE />
        <ABOUT />
        <CONTACT />
      </main>
       <FOOTER />
       <WhatsAppButton />
       <ScrollToTop />
       <CookieConsent />
    </div>
  );
}

export default App;
